import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as CONSTANTS from "../CONSTANTS";
import axios from 'axios';

function UserDetails() {
    const {user}                                                       = useSelector((state) => state.auth);
    
    const params                                                       = useParams();

    const [currentUser, setCurrentUser]                                = useState(null);

  useEffect(() => {
    collectSingleUserDetails()
  },[])


  const collectSingleUserDetails = async () => {
    try{
      
      const res = await axios.get(CONSTANTS.API_URL +"users/find/" + params.id);
   
      setCurrentUser(res.data);
    }catch(err){
      console.log(err);
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        <h3 class="inner-part">User Details</h3>
         {
            currentUser  !== null && (
                <table className="table table-striped">
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>:</td>
                            <td>{currentUser.name}</td>
                        </tr>
                        <tr>
                            <td>Surname</td>
                            <td>:</td>
                            <td>{currentUser.surname}</td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>:</td>
                            <td>{currentUser.email}</td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td>:</td>
                            <td>{currentUser.phone}</td>
                        </tr>
                    </tbody>
                </table>
            )
         }
        </div>
      </div>
  )
}

export default UserDetails